import React from 'react';
import HeroSection from './component/HeroSection';
import Service from './Services';
import Contact from './Contact'

const homeData = {
  subhead: "Hey There ! I'm ",
  name: "Venkatesh Moyya",
  myRole: "MERN Stack Developer & Technical Mentor",
  myInfo: (
    <p>
      A Full-Stack Developer and Technical Trainer with expertise in the <strong>MERN stack</strong> (MongoDB, Express.js, React.js, Node.js) and Python. I have successfully mentored over <strong>2000 students</strong> in full-stack development and DSA, helping them transition from learners to industry-ready professionals.
      <br /><br />
      Currently working as a <strong>Technical Mentor & DSA Instructor</strong> at ByteXL. I specialize in building scalable web applications and delivering <strong>project-based learning</strong>.
    </p>
  ),  
  image: "../images/profile.jpg",
}

const Home = () => {
  return (
    <>
      <HeroSection { ...homeData }/>
      <Service />
      <Contact />
    </>
  )
}

export default Home
